/** Bank account types (banking / withdraw → user_bank API) */
export const BANKS = [
  {
    accountCode: 'KBZ_PAY',
    paymentCode: 'kbz_mmk',
    name: 'KBZpay',
    link: 'https://cdn.gold549.com/build/assets/img/payments/kpay.png',
  },
  {
    accountCode: 'WAVE_PAY',
    paymentCode: 'wave_mmk',
    name: 'WavePay',
    link: 'https://cdn.gold549.com/build/assets/img/payments/wavepay.png',
  },
];

export const DEFAULT_BANK_ACCOUNT_CODE = 'KBZ_PAY';
export const DEFAULT_PAYMENT_CODE = 'kbz_mmk';

/** AccountSelect: id sent as bank account type */
export const BANK_ACCOUNT_OPTIONS = BANKS.map((bank) => ({
  id: bank.accountCode,
  name: bank.name,
  link: bank.link,
}));

/** Auto deposit: payment code sent to /auto-deposits */
export const PAYMENT_BANK_OPTIONS = BANKS.map((bank) => ({
  code: bank.paymentCode,
  name: bank.name,
}));

export function getBankName(code) {
  const bank = BANKS.find(
    (b) => b.accountCode === code || b.paymentCode === code,
  );
  return bank ? bank.name : code;
}

/** Map stored deposit bank (API/provider codes) to client auto-deposit payment code */
export function resolvePaymentCode(storedBank) {
  const bank = (storedBank || '').toLowerCase();

  if (bank.includes('kbz')) {
    return 'kbz_mmk';
  }
  if (bank.includes('wave')) {
    return 'wave_mmk';
  }

  const match = BANKS.find(
    (item) => item.paymentCode === storedBank || item.accountCode === storedBank,
  );

  return match ? match.paymentCode : storedBank || DEFAULT_PAYMENT_CODE;
}
